export const NUMBER_OF_WEEK_DAYS = 7
export const OFFSET_HOURS = 4
export const ONE_SECOND = 1000
export const ONE_MINUTE_TIMESTAMP = 60 * ONE_SECOND
export const ONE_HOUR_TIMESTAMP = 60 * ONE_MINUTE_TIMESTAMP
export const ONE_DAY_TIMESTAMP = ONE_HOUR_TIMESTAMP * 24
export const GRID_TIMESTAMP = ONE_MINUTE_TIMESTAMP
export const NUMBER_OF_ONE_DAY_GRID = ONE_DAY_TIMESTAMP / GRID_TIMESTAMP
export const INHALER_USAGES_GRID_TIMESTAMP = ONE_MINUTE_TIMESTAMP * 15
export const NUMBER_OF_ONE_DAY_INHALER_USAGES_GRID = ONE_DAY_TIMESTAMP / INHALER_USAGES_GRID_TIMESTAMP
export const OFFSET_HOURS_TIMESTAMP = ONE_HOUR_TIMESTAMP * OFFSET_HOURS
export const ONE_DAY_HEIGHT = 23

export enum Z_INDEX {
  SLEEP,
  ACTIVITY,
  INTERRUPTION,
  INHALER_USAGE,
  INHALER_USAGE_OVERLAP,
}

export const INHALER_USAGE_ICONS_BASE64 = {
  CIRCLE:
    'iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAVFBMVEVHcEwORMwORMwORMwNRMwORMwNRcwHP88MQswORcwORMwORMwORM0ORMwNRMwORMz///8PRc3v8/yGoebC0PN3luM8aNY7Z9azxO94luOHoubD0fOUFhluAAAAEHRSTlMA8O/QcKBgIFDA4L+fz2/ftjgeUAAAALRJREFUKM91kkcOwzAMBNe2HMqpHLql/P+fOaTJATTHWWEFUZRe2PlwgdPhbCqxI1+ORZRbCtr88Tv+2JV+HaeIaVwByJJkLcDsL2IGaE1SD3D1L1eAXrLyvLu7zwCmBKyl91iBpAEYN4GPwKA9MG2DCTgJILZBANSDSlVXvzwBy6YrFiDVH1gdiawBuL3b4gbQmCRlAJb7I+JxX35jr3+UlJtSN7lYhv7n+789SUMH3ZA++gnN2B2LflZUIAAAAABJRU5ErkJggg==',
  CIRCLE_BG:
    'iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAPFBMVEVHcEwORMwORMwORMwNRMwORMwNRcwHP88MQswORcwORMwORMwORM0ORMwNRMwORMwPRc0ORM0ORc0ORMwKMEWUAAAAEHRSTlMA8O/QcKBgIFDA4L+fz2/ftjgeUAAAAJhJREFUeF51kY0OwyAIhFGx6Pqzs3v/d92KjpCmfjEROD2C0kCO9Q3s6yHkkQ3G5qQS4YiFBgtuLL7eBproHVGfE52mQbz6ZAD4QLEwE4k/D0uEGECDR/sw1Zsw0kqvZ2EnPAuYCjOrNG/OAE5TbHieDjh/EpJg49oeRL+pG7Sz/VY3LdOPGpQARyhkSIaRhTzCNQGp8r/8BS2dHBUtQGiFAAAAAElFTkSuQmCC',
  CIRCLE_CIRCLE:
    'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEVHcEwNQ80ORMwKRc8ORMwMQswORcwAP88ORMwHP88ORMwORM0ORMwORMwORMwMQ84ORc0ORMwORMwOQ80sW9MPRc3R3PbC0PP///8ORM1af9wORc1Kc9mGoeakuex3luMdT88tXNNoit/v8/weUNBLc9mluex4luPD0fOHouZpi+BZftzg5/kAViRUAAAAFHRSTlMAgM8w0FDAEKAg75/w379PkOB/jxOX/BoAAAFcSURBVHhehVIHkoMwDDQJYBNIrtmml/R2/3/fSSIyPnJlhxlkrZrlFRPkS7pZG7PepC9SPCNJjYc0mdHyw8zwLr/xC/OEhRexXBGh+/yzKGzeazquli6feN0VDp2mCOnXv+8LD/u71+UV7R0S+fV4OByvOdo79AZ0P+b3Fc9XYTWqgbdV2B88dmscthbicQ4FE6CjgzPxLgIyOjSkiLAAV6xLQE1dwIUlIurQw3zIl2DzDybtqUc8HlrMJ/phtGNSLNbAwP4azuQSDYyNqxDogH7DPOAATrR/DRg44O3vFqE/ZPnTkP9fM8K98aLKuoSPHwd3G02r1saDnlYt1GP1Vnu8fTyO4ueuWCSEHYqn4ucWAVo3EkzbDEPTkmBuTjBChiwSBosnZFFmJIHTxJ9IHJl0ss9GlZwvMJy9nIFGnmXPXXxwfQcZzPmAeUaifFol4hkyUjG0CmMVedlfyaxH317Eq4sAAAAASUVORK5CYII=',
  CIRCLE_SQUARE:
    'iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAh1BMVEVHcEwNQ80ORMwKRc8ORMwMQswORcwAP88ORMwHP88ORMwORMwORM0ORMwMQ84ORMwORc0ORMwOQ80ORMz///8PRc3v8/wtXNPR3Pakuex3luPC0PMsW9MORM1af9xoit9Zftzg5/lpi+B4luOluezD0fOzxO87Z9Y8aNYeUNAORc1Kc9lLc9l9jpEYAAAAFHRSTlMAgM8w0FDAEKAg7/Cf30+/kH+P4PveK4UAAAFFSURBVHheZZJXkoMwEESFCRIY7A0KBOe46f7nW2Zk1MLuD4qq9zQtCQQiV/W6MaZZ1yspXlPWJkpdPmH5YZ7yLmd8YV6yiIy0YrDph6PW7dBv2KjSsL5i3Okx7Z8dnx0rlYznHyzzb/NFhj1ELW/E9/rBjTf0noyEeDnnweAZdFpF/XbiMCztQwkhSezAt8HoiEiR0wDwny0MGpFzQw9uDIyeO4pRGCIeGcOICtGM4AgeGy1dhSAAPjeIeeEXCzn+7cbCJ1XYOzeQgZeOKrLHJmGA+00+jgkD3B+TL8ppGODa8UVJr8PwHFfNHc4Gw4QFjhqmz73T3gDXu+lzi4SMkzfAT+GHETLjGaGF5/P6bPopl2S4CxvML474kjgnZcO487W1t/Z6doZ56ilakDAfRvLME8+RUsVYlSDoyVUxVmWFyiXAP1tqRwVuevHMAAAAAElFTkSuQmCC',
  SQUARE:
    'iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAAzElEQVR4AWJwL/ABtEaHIAjEABSG18HTDtp7B8td1qrJaO9ot3cN9m6vO272gR3M1smEV0SD//PBD4MxvrCfG3Vx07T9sZ5JCBx3falRGIMOzEED5qABY3C6GDCMwPPlXq75gWEEahSmoAVbIIVtkMA+CGAfBLAPAjg0bTy9X86W6fXQ2WqXP6AxhfkwCVX+N7w93L6C+lMAc1AogDkoFMAcFApgDgoFMAeFEhiDQhG83mcECiUwBoUCmINCAcxBoRgmoFAEU1AoSiDpCSJEGnSkdZ4RAAAAAElFTkSuQmCC',
  SQUARE_BG:
    'iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAAAqElEQVR4AWJwL/AhGfO6nkngczk7H9BKHWAgGAQBFP5vUDcK6p4dqNSNqsUDFnwTHsPgs5ZZs0Tg6fb8rBRmcAKPQIUHoMMAhjwYNrAQBrDZYQYnsIMD2MEB7OAAdnAAOziAj9/yvlmGOnzdHpT3cXmdjyX/F+6Ve7A/BdjBUIAdDAXYwVCAHQwF2MFQgB0MBdjBUIEZDAUYQEGDEXQ0GEFHgwF0tASsL0NEEaHx/HmiAAAAAElFTkSuQmCC',
  SQUARE_CIRCLE:
    'iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAMAAADWg4HyAAAAQlBMVEVHcEwORMwKRc8HP88NRcwORMwORM0PRc07Z9bv8/w8aNZoit+VrekORc1pi+AtXNOkueyWrukORM3R3Pb///8sW9M8ilF8AAAAB3RSTlMAoDAgYPCfcbBIRgAAAORJREFUeF6F0tluxDAMQ9G001aSs83W///Vwkgwd1QLIB/ilwPCoDNV+fqZRKBmYEnBmoI1BWv6C1b0Gg4W9PkESwrWFKyoxFCJoRpD47Y1a9stEi7pY7cj7QGu6dUIO9et9h6aCxp7J/fV1nsnLcDDAksXq72+C2sMY829taPznNN0eVd/1R5nyzt/dLrHYe1/joqtm+/LiVuUvf5GP6cJXN03U3C9AxTMmOzrMVDw8G7QEef/IdGq2U/pqbXGscxuPi+RaI0JVGGoxFCJoRJDJYZqDNUYqjFUY6jGUI2hOpcS/AHufiUiSk29cgAAAABJRU5ErkJggg==',
  SQUARE_SQUARE:
    'iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAMAAADWg4HyAAAARVBMVEVHcEwORMwKRc8HP88NRcwORMwORM0PRc3v8/z///+kuewORM0ORc2zxO9pi+A7Z9bR3PYeUNA8aNYsW9MtXNNLc9lKc9mWv0tGAAAAB3RSTlMAoDAgYPCfcbBIRgAAAKlJREFUeF51y9cOAjEMBdHAAs42avn/T2WLFCGNZ56u5OOSdboUiTQC2CmxU2KnxE5fwEqHegM22vfAToGdEju9fyqw0Uc8gZUGsFNip8ROR2Cl0wisNALYaYKNCs6o4sMK3nWx3yb29jUvl+s6zt2G/9+njbQxNHosJcFGBWdUcEYVkyoOUMekjkkdkzomdTyDOiZ1TOqY1DGpY1LHpI5JHZM6JvW6FPwAwb0eAiUOUU4AAAAASUVORK5CYII=',
}

export const INHALER_USAGE_ICONS = {
  maintenance: [
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.SQUARE,
      symbolSize: 12,
    },
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.CIRCLE,
      symbolSize: 14,
    },
  ],
  maintenance1OverlapWithReliever: [
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.SQUARE_CIRCLE,
      symbolSize: 17,
    },
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.SQUARE_SQUARE,
      symbolSize: 17,
    },
  ],
  maintenance2OverlapWithReliever: [
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.CIRCLE_CIRCLE,
      symbolSize: 22,
    },
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.CIRCLE_SQUARE,
      symbolSize: 22,
    },
  ],
  reliever: [
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.CIRCLE_BG,
      symbolSize: 12,
    },
    {
      symbol: 'image://data:image/png;base64,' + INHALER_USAGE_ICONS_BASE64.SQUARE_BG,
      symbolSize: 14,
    },
  ],
}
